import { Outlet } from "react-router-dom";
import React, { useEffect } from "react";

const Spaces = () => {
  return (
    <div className="w-full h-full">
      <Outlet />
    </div>
  );
};

export default Spaces;
